import { TwoFactorType } from './TwoFactorType';

export class TwoFactorAuthenticationRequest {
  email: string;
  type: TwoFactorType;

  constructor() {}
}